
// Protect copy , inspect 
export const protectEvent = (clientId) => {
    var ele = document.getElementById(`container-${clientId}`);
    ele.setAttribute("oncopy", "return false");
    ele.setAttribute("oncut", "return false");
    ele.setAttribute("onpaste", "return false");

    document.getElementById(`container-${clientId}`).addEventListener("contextmenu", function (e) {
        e.preventDefault();
    });

    document.getElementById(`container-${clientId}`).addEventListener("keypress", function (e) {
        var str;
        var i;
        for (i in e) {
            str = str + i + ": " + e[i] + "<br />";
        }
        document.getElementById("innerContainer").innerHTML = str;
    });
}

export const clickOpenMailTo = (content) => {
    window.location.href = `mailto:${content?.email}`;
}

export const clickOpenTelTo = (content) => {
    window.location.href = `tel:${content?.phone}`;
}

export const clickOpenTab = (content) => {
    window.open(content?.url, "_blank");
}


export const checkContent = (contentType, setenCode, enCodeContent, content) => {
    if (contentType === "email") {
        setenCode(enCodeContent(content?.email));
    }
    else if (contentType === "phone") {
        setenCode(enCodeContent(content?.phone));
    }
    else if (contentType === "text") {
        setenCode(enCodeContent(content?.text));
    }
    else {
        setenCode(enCodeContent(content?.url));
    }
}

export const openTool = (clientId, contentType, content) => {
    const text = window.btoa(content?.text);
    const email = window.btoa(content?.email);
    const phone = window.btoa(content?.phone);
    const url = window.btoa(content?.url);

    if (document.querySelector(`.content-${clientId}`)) {
        if (contentType === 'text') {
            document.querySelector(`.content-${clientId} span`).innerHTML = text;
        }
        else if (contentType === 'email') {
            document.querySelector(`.content-${clientId} a`).innerHTML = email;
        }
        else if (contentType === 'phone') {
            document.querySelector(`.content-${clientId} a`).innerHTML = phone;
        }
        else {
            document.querySelector(`.content-${clientId} a`).innerHTML = url;
        }
    }
}

export const reverseString = (str) => {
    return str.split('').reverse().join('');
}

export const closeTool = (clientId, setWindowSize, contentType, content) => {
    if (document.querySelector(`.content-${clientId}`)) {
        setWindowSize({ width: window.innerWidth + 10, height: window.innerHeight + 10 });
        if (contentType === "text") {
            document.querySelector(`.content-${clientId} span`).innerHTML = reverseString(content?.text);
        }
        else if (contentType === 'email') {
            document.querySelector(`.content-${clientId} a`).innerHTML = reverseString(content?.email);
        }
        else if (contentType === 'phone') {
            document.querySelector(`.content-${clientId} a`).innerHTML = reverseString(content?.phone);
        }
        else {
            document.querySelector(`.content-${clientId} a`).innerHTML = reverseString(content?.url);
        }
    }
}

